import { expertise } from "../data/skills";
export function Expertise() {
  return (
    <div className="expertise" data-reveal>
      <div>
        <span className="eyebrow">THE TOOLKIT</span>
        <h3>Chosen for the job.</h3>
      </div>
      <div className="expertise-grid">
        {expertise.map((group) => (
          <div key={group.title}>
            <h4>{group.title}</h4>
            <p>{group.items}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
